import { MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { Collapse, Empty, message, Space } from "antd";
import { useQuery } from "react-query";
import BackToPage from "../../../components/BackToPage";
import { EMPTY_MESSAGE, FIELD_FROM_DATA_SERVER } from "../../../constants";
import { getFaq } from "../../../services/FaqService";
import { useStore, actions } from "../../../store";
import { errorMessage } from "../../../utils/messages/error-message";
import "./styles.scss";
import { useEffect } from "react";

const QA = () => {
  const [state] = useStore();
  const { Panel } = Collapse;
  const [_, dispatch] = useStore();
  const stylesBackground = { background: "#ffffff" };
  const group_id_from_fc = sessionStorage.getItem("group_id_from_fc");

  const { data, error } = useQuery(
    ["faq"],
    () => getFaq(Number(group_id_from_fc)),
    {
      cacheTime: 2 * 1000,
      staleTime: 60 * 1000,
    }
  );

  useEffect(() => {
    dispatch(actions.setHeaderTitle("よくある質問"));
  }, [dispatch]);
  let ListFQA = <></>;
  if (error) {
    message.error(errorMessage.errorNetWork);
    ListFQA = (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_MESSAGE} />
    );
  } else if (data?.length !== 0) {
    ListFQA = data?.map((item: any, idx: number) => {
      return (
        <Collapse
          bordered={true}
          expandIcon={({ isActive }) =>
            isActive ? <MinusOutlined /> : <PlusOutlined />
          }
          className="site-collapse-custom-collapse"
          expandIconPosition="end"
          style={stylesBackground}
          key={idx}
        >
          <Panel key={idx} header={`${item.faq}`}>
            <div
              className="text-content"
              dangerouslySetInnerHTML={{
                __html: item.convension,
              }}
            ></div>
          </Panel>
        </Collapse>
      );
    });
  } else {
    ListFQA = (
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={EMPTY_MESSAGE} />
    );
  }

  return (
    <div className="qna-page">
      <BackToPage />
      <div className="content">
        <Space direction="vertical">{ListFQA}</Space>
      </div>
    </div>
  );
};

export default QA;
